module.exports = __webpack_public_path__ + "img/1557614073453027329.a4c1581a.png";